module.exports = __webpack_public_path__ + "img/wecare-iphone-xr.b40f4888.png";